<template>
  <div class="left-menu">
    <div class="btn" :class="{ active: activeRouter === 'HistoricalRanking' }" @click="pathTo('HistoricalRanking')"><i class="iconfont icon-paimingliebiao"></i>历史排名</div>
    <div class="btn" :class="{ active: activeRouter === 'HistoricalData' }" @click="pathTo('HistoricalData')"><i class="iconfont icon-jiankongshuju"></i>历史数据</div>
    <div class="btn" :class="{ active: activeRouter === 'DataAnalysis' }" @click="pathTo('DataAnalysis')"><i class="iconfont icon-jiankongshuju"></i>数据分析</div>
    <div class="btn" :class="{ active: activeRouter === 'AssociationMining' }" @click="pathTo('AssociationMining')"><i class="iconfont icon-tongjiwajue"></i>关联挖掘</div>
  </div>
</template>

<script>
export default {
  name: "LeftMenu",
  props: {
    activeRouter: { type: String, default: 'VideoSurveillance' }
  },
  methods: {
    pathTo (name) {
      if (!name) {
        return this.$message.warning('该模块开发中...')
      }
      this.$router.push({ name: name })
    }
  }
}
</script>

<style scoped lang="less">
.left-menu{
  padding: 42px 0;
  .btn{
    margin: 0 48px 26px 48px;
    cursor: pointer;
    width: 215px;
    height: 68px;
    text-align: center;
    line-height: 68px;
    font-size: 24px;
    font-weight: 500;
    color: #FFFFFF;
    background-image: url("../../../assets/img/btn.png");
    background-size: 100% 100%;
    i{
      font-size: 28px;
      margin-right: 10px;
    }
  }
  .active{
    width: 225px;
    margin-left: 43px;
    margin-right: 43px;
    height: 74px;
    line-height: 74px;
    background-image: url("../../../assets/img/btn-active.png");
  }
}
</style>
